import { render, staticRenderFns } from "./PoiDetailQuestion.vue?vue&type=template&id=abff7fae&scoped=true&"
import script from "./PoiDetailQuestion.vue?vue&type=script&lang=js&"
export * from "./PoiDetailQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PoiDetailQuestion.vue?vue&type=style&index=0&id=abff7fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abff7fae",
  null
  
)

export default component.exports